// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__24tlK","imageUploader":"EGiftCard_imageUploader__1ifB6"};